import { render, staticRenderFns } from "./AdnAuthorize.vue?vue&type=template&id=1e94b052&scoped=true"
import script from "./AdnAuthorize.vue?vue&type=script&lang=js"
export * from "./AdnAuthorize.vue?vue&type=script&lang=js"
import style0 from "./AdnAuthorize.vue?vue&type=style&index=0&id=1e94b052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e94b052",
  null
  
)

export default component.exports